import React, { useEffect, useRef, useState } from "react";
import { fetchTeamAssociates } from "../../../containers/actions/common/teamMemberAction";
import {
  DELETE_COLLABORATOR_ROLE,
  FETCH_TEAM_ASSOCIATES_LOADING,
  UPDATE_COLLABORATOR_ROLE_CHANGES,
} from "../../../containers/actions/types";
import { useDispatch, useSelector } from "react-redux";
import DeleteOutlinedIcon from "@material-ui/icons/DeleteOutlined";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import {
  Avatar,
  Backdrop,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  Drawer,
  FormControl,
  FormControlLabel,
  Grid,
  makeStyles,
  MenuItem,
  Paper,
  Slide,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  TextField,
  Typography,
} from "@material-ui/core";
import VisibilityIcon from "@material-ui/icons/Visibility";
import AddIcon from "@material-ui/icons/Add";
import InviteTeamMember from "./inviteTeamMember";
import ViewDetails from "../teamMembers/viewDetails";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import {
  deleteCollaboratorRole,
  updateCollaboratorRoleChanges,
} from "../../../containers/actions/common/rolesAndAccessActions";
import usePrevious from "../../helpers/previousProps";
import BackDropLoading from "../models/BackDrop";
import { ChevronRight } from "@material-ui/icons";
import { convertToLocaleDateTime } from "../functionalComponents/FormatDateTimeToLocale";

// const calculateDaysAgo = (date) => {
//   const today = new Date();

//   // Convert UTC date to IST
//   const givenDate = new Date(date);
//   const istOffset = 5 * 60 + 30; // IST offset in minutes
//   const istDate = new Date(givenDate.getTime() + istOffset * 60 * 1000);

//   // Difference calculation: compare today (local time) with given date (adjusted to IST)
//   const differenceInMilliseconds = today - istDate;
//   const differenceInDays = Math.floor(
//     differenceInMilliseconds / (1000 * 60 * 60 * 24)
//   );

//   if (differenceInDays === 0) {
//     const differenceInHours = Math.floor(
//       differenceInMilliseconds / (1000 * 60 * 60)
//     );
//     if (differenceInHours === 0) {
//       const differenceInMinutes = Math.floor(
//         differenceInMilliseconds / (1000 * 60)
//       );
//       if (differenceInMinutes <= 1) {
//         return "Now"; // Event occurred just now or less than 1 minute ago
//       }
//       return `${differenceInMinutes} minutes ago`;
//     }
//     return `${differenceInHours} hour${differenceInHours > 1 ? "s" : ""} ago`;
//   }
//   return `${differenceInDays} day${
//     differenceInDays > 1 ? "s" : ""
//   } ago at ${istDate.toLocaleTimeString("en-IN", {
//     hour: "2-digit",
//     minute: "2-digit",
//     hour12: true,
//   })}`;
// };

const calculateDaysAgo = (date) => {
  if (!date) return "Invalid Date";

  const today = new Date(); // Get current local time
  const localDate = new Date(convertToLocaleDateTime(date)); // Convert UTC to local time

  const differenceInMilliseconds = today - localDate;
  const differenceInDays = Math.floor(
    differenceInMilliseconds / (1000 * 60 * 60 * 24)
  );

  if (differenceInDays === 0) {
    const differenceInHours = Math.floor(
      differenceInMilliseconds / (1000 * 60 * 60)
    );
    if (differenceInHours === 0) {
      const differenceInMinutes = Math.floor(
        differenceInMilliseconds / (1000 * 60)
      );
      if (differenceInMinutes <= 1) {
        return "Now"; // Event occurred just now or less than 1 minute ago
      }
      return `${differenceInMinutes} minutes ago`;
    }
    return `${differenceInHours} hour${differenceInHours > 1 ? "s" : ""} ago`;
  }

  return `${differenceInDays} day${differenceInDays > 1 ? "s" : ""} ago`;
};

const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 650,
  },
  active: {
    backgroundColor: "#2e7d32",
    color: "white",
    width: "6rem",
    padding: "5px 10px",
    borderRadius: "5px",
    textAlign: "center",
  },
  inactive: {
    backgroundColor: "#f44336",
    width: "6rem",
    color: "white",
    padding: "5px 10px",
    borderRadius: "5px",
    textAlign: "center",
  },
  searchField: {
    marginBottom: theme.spacing(2),
  },
  dialogContent: {
    textAlign: "center",
    padding: "24px 36px 24px 36px",
  },
  avatar: {
    color: "green",
    margin: "0 auto",
    fontSize: "54px",
  },
  dialogActions: {
    justifyContent: "center",
    marginTop: theme.spacing(2),
  },
  upload: {
    background: "#c8ddfb",
    color: "black",
    textTransform: "none",
    borderRadius: "2rem",
    // marginRight: 20,
    padding: "5px 20px",
    "&:hover": {
      backgroundColor: "#6495ED",
      color: "white",
    },
  },
  drawerPaper: {
    width: "30vw", // Set the drawer width here
  },
  multipleLogo: {
    border: "1px solid #7d7c7c",
    borderRadius: "4px",
    padding: "0.3rem",
    height: "inherit",
    marginLeft: "0.5rem",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "black",
      color: "white",
      border: "1px solid #FFF",
    },
  },
}));

const EditTeamMembersColumn = ({
  // teamMembersList,
  // teamMembersListLoading,
  fetchDepartmentsList,
  departmentDetails,
  featuresAccess,
  openDialog,
  handleRefresh,
  selectedRole,
  handleCloseColumn,
  closeEditScreen,
  openSuccessDialog,
  setOpenSuccessDialog,
  featuresAccessTeamMembers,
  //  openDialog,handleClose,handleRefresh
}) => {
  const classes = useStyles();
  const didMountRef = useRef(false);
  const dispatch = useDispatch();
  const [inviteDrawer, setInviteDrawer] = useState(false);
  const [ViewDetailsDrawer, setViewDetailsDrawer] = useState(false);
  const [user, setUser] = useState({});
  const [view, setView] = useState("TeamMembers"); // Current tab view
  const [showDrawer, setShowDrawer] = useState(false);
  const [roleName, setRoleName] = useState("");
  const [initialDepartmentName, setInitialDepartmentName] = useState(
    selectedRole.departmentName
  );
  const [initialRoleName, setInitialRoleName] = useState(""); // Initial role name
  const [roleDescription, setRoleDescription] = useState(
    selectedRole.role_description
  );
  const [originalDescription, setOriginalDescription] = useState(
    selectedRole.role_description
  ); // Backup of original
  const [editingDescription, setEditingDescription] = useState(false);
  const [editingRoleName, setEditingRoleName] = useState(false);
  const [deleteRole, setDeleteRole] = useState(false);
  const [updateError, setUpdateError] = useState(false);
  const [updatedData, setUpdatedData] = useState({});
  const [openDrawer, setOpenDrawer] = useState(false);
  // const [openSuccessDialog, setOpenSuccessDialog] = useState(false);
  const [userDepartmentRole, setUserDepartmentRole] = useState({});
  const [autofillChecked, setAutofillChecked] = useState(false);

  const teamMembersList = useSelector((state) => {
    return state?.pcmp?.common?.teamMembers?.teamMembersDetails;
  });

  const teamMembersListLoading = useSelector((state) => {
    return state?.pcmp?.common?.teamMembers?.teamMembersDetailsLoading || {};
  });

  const updateCollaboratorRoleData = useSelector(
    (state) => state?.pcmp?.common?.rolesAndAccess?.updateCollaboratorRole || {}
  );

  const DeleteCollaboratorRoleData = useSelector((state) => {
    return state?.pcmp?.common?.rolesAndAccess?.deleteCollaboratorRole
      ? state?.pcmp?.common?.rolesAndAccess?.deleteCollaboratorRole
      : [];
  });

  const prevUpdateCollaboratorRoleData = usePrevious(
    updateCollaboratorRoleData
  );

  useEffect(() => {
    if (selectedRole?.role_name) {
      setRoleName(selectedRole.role_name);
      setInitialRoleName(selectedRole.role_name);
    }
  }, [selectedRole]);

  // const handleClose = () => {
  //   dispatch({
  //     type: UPDATE_COLLABORATOR_ROLE_CHANGES,
  //     value: {},
  //   });
  //   handleRefresh();
  //   setOpenSuccessDialog(false);
  //   handleCloseColumn();
  //   // closeEditScreen();
  // };

  const handleTabChange = (event, newValue) => {
    setView(newValue);
  };

  useEffect(() => {
    if (selectedRole) {
      dispatch({
        type: FETCH_TEAM_ASSOCIATES_LOADING,
        payload: true,
      });
      dispatch(
        fetchTeamAssociates({
          departmentID: selectedRole?.departmentID,
          collaborator_role_id: selectedRole?.collaborator_role_id,
          searchString: "all",
          status: "Active",
        })
      );
    }
  }, [selectedRole]);

  const UserAvatar = ({ profileImage, profileName }) => {
    return (
      <Box display="flex" alignItems="center">
        <Avatar
          src={profileImage} // Use the Base64 string here
          alt={profileName} // Optional: Alt text for accessibility
          style={{ marginRight: "8px" }} // Adjust spacing if needed
        />
      </Box>
    );
  };

  const handleRenameChanges = () => {
    setUpdateError(false);
    dispatch({
      type: UPDATE_COLLABORATOR_ROLE_CHANGES,
      payload: {},
    });
    setEditingRoleName(false);
    const requestObject = {
      collaboratorRoleData: {
        collaboratorRoleDetails: {
          collaborator_role_id: selectedRole?.collaborator_role_id,
          role_name: roleName,
          role_description: null,
        },
        screensAndFeatures: null,
      },
    };

    dispatch(updateCollaboratorRoleChanges(requestObject));
  };

  useEffect(() => {
    if (didMountRef.current) {
      if (
        JSON.stringify(updateCollaboratorRoleData) !==
        JSON.stringify(prevUpdateCollaboratorRoleData)
      ) {
        if (updateCollaboratorRoleData.status === true) {
          // setLoading(false);
          setUpdateError(false);
          setUpdatedData(updateCollaboratorRoleData);
          setOpenSuccessDialog(true);
        } else if (updateCollaboratorRoleData.status === false) {
          // setLoading(false);
          setUpdateError(true);
          scrollToTop();
          setUpdatedData(updateCollaboratorRoleData);
          setOpenSuccessDialog(false);
        }
      }
    } else {
      didMountRef.current = true;
    }
  }, [updateCollaboratorRoleData, prevUpdateCollaboratorRoleData]);

  const handleDiscardChanges = () => {
    setRoleDescription(originalDescription);
    setEditingDescription(false);
  };

  const errRef = useRef();
  const scrollToTop = () => {
    setTimeout(
      () => errRef.current.scrollIntoView({ behavior: "smooth", block: "end" }),
      100
    );
  };

  const handleSaveChanges = () => {
    setUpdateError(false);
    dispatch({
      type: UPDATE_COLLABORATOR_ROLE_CHANGES,
      payload: {},
    });
    setEditingDescription(false);
    const requestObject = {
      collaboratorRoleData: {
        collaboratorRoleDetails: {
          collaborator_role_id: selectedRole?.collaborator_role_id,
          role_name: null,
          role_description: roleDescription,
        },
        screensAndFeatures: null,
      },
    };

    dispatch(updateCollaboratorRoleChanges(requestObject));
  };

  const isSaveDisabled = roleDescription === originalDescription;

  const handleDetailView = (user) => {
    setUser(user);
    setViewDetailsDrawer(true);
    // fetchDepartmentsList
  };
  // const fetchDepartmentsList = [];
  // const handleRefresh = () => {};

  const handleProceedDelete = () => {
    // setShowDrawer(false);
    setUserDepartmentRole({});
    setAutofillChecked(false);
    setOpenDrawer(true);
  };

  const handleDeleteRole = () => {
    if (selectedRole?.userCount === 0) {
      dispatch(
        deleteCollaboratorRole({
          collaborator_role_id: selectedRole?.collaborator_role_id,
          saasUserChangesList: [],
        })
      );

      dispatch({
        type: DELETE_COLLABORATOR_ROLE,
        payload: {},
      });

      setDeleteRole(true);
    } else {
      setShowDrawer(true);
    }
  };

  const handleConfirmChanges = () => {
    setDeleteRole(true);
    setOpenDrawer(false);
    setShowDrawer(false);
    dispatch({
      type: DELETE_COLLABORATOR_ROLE,
      payload: {},
    });

    if (selectedRole) {
      const saasUserChangesList = Object.entries(userDepartmentRole)
        .map(([userID, roleInfo]) => {
          if (!roleInfo) return null;

          const { selectedDepartmentID, selectedRoleId, markedDepartment } =
            roleInfo;

          if (!selectedRoleId || !markedDepartment) return null; // Skip if no role is selected

          // Find the matching role object
          const selectedRoleObj = markedDepartment.rolesList.find(
            (role) => role.collaborator_role_id === selectedRoleId
          );

          if (!selectedRoleObj) return null; // Skip if no role object is found

          return {
            saas_user_id: Number(userID), // Ensure correct ID format
            department_id: selectedDepartmentID,
            collaborator_role_id: selectedRoleObj.collaborator_role_id,
          };
        })
        .filter(Boolean); // Remove null values

      dispatch(
        deleteCollaboratorRole({
          collaborator_role_id: selectedRole?.collaborator_role_id,
          saasUserChangesList: saasUserChangesList,
        })
      );
    }
  };

  const handleDepartmentChange = (userID, departmentID) => {
    setUserDepartmentRole((prevState) => {
      const selectedDept = fetchDepartmentsList?.find(
        (dept) => dept.departmentID === departmentID
      );

      if (!selectedDept) return;

      return {
        ...prevState,
        [userID]: {
          ...prevState[userID],
          selectedDepartmentID: departmentID,
          // markedDepartment: selectedDept,
          markedDepartment: {
            ...selectedDept, // ✅ Ensures correct department data is set
            rolesList: selectedDept.rolesList || [], // Avoids undefined rolesList
          },
          selectedRole: null, // Reset role when department changes
          selectedRoleId: null,
        },
      };
    });
  };

  const getFirstUserId = () => {
    const firstUser = teamMembersList?.data?.find(
      (user) =>
        userDepartmentRole[user.saas_user_id]?.selectedDepartmentID &&
        userDepartmentRole[user.saas_user_id]?.selectedRole
    );
    return firstUser?.saas_user_id;
  };

  const handleAutofillChange = (event) => {
    const isChecked = event.target.checked;
    setAutofillChecked(isChecked);

    if (isChecked) {
      const firstUserId = getFirstUserId();
      if (!firstUserId) return;

      const firstUserDept =
        userDepartmentRole[firstUserId]?.selectedDepartmentID;
      const firstUserRole = userDepartmentRole[firstUserId]?.selectedRole;
      const firstUserMarkedDept =
        userDepartmentRole[firstUserId]?.markedDepartment;

      if (!firstUserDept || !firstUserRole || !firstUserMarkedDept) {
        // alert("Please select department and role for the first user first.");
        setAutofillChecked(false);
        return;
      }

      setUserDepartmentRole((prevState) => {
        const updatedState = { ...prevState };

        // Ensure data is available
        if (teamMembersList?.data?.length > 0) {
          teamMembersList.data.forEach((user) => {
            if (user.saas_user_id !== firstUserId) {
              updatedState[user.saas_user_id] = {
                ...prevState[user.saas_user_id], // Preserve existing data
                selectedDepartmentID: firstUserDept,
                selectedRole: firstUserRole,
                markedDepartment: firstUserMarkedDept,
              };
            }
          });
        }

        return updatedState; // Return the updated state
      });
    }
  };

  const handleRoleChange = (userID, roleName) => {
    setUserDepartmentRole((prevState) => {
      const updatedDepartment = prevState[userID]?.markedDepartment; // Ensure latest department data
      const selectedRole = updatedDepartment?.rolesList?.find(
        (role) => role.role_name === roleName
      );

      return {
        ...prevState,
        [userID]: {
          ...prevState[userID],
          selectedRole: roleName,
          selectedRoleId: selectedRole?.collaborator_role_id || null,
          saas_user_id: userID,
        },
      };
    });
  };

  const handleConfirmDelete = () => {
    dispatch({
      type: DELETE_COLLABORATOR_ROLE,
      value: {},
    });
    setDeleteRole(false);
    // closeEditScreen();
    handleCloseColumn();
    handleRefresh();
  };

  const renderTeamMembers = () => (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "flex-end",
          marginBottom: "2rem",
        }}
      >
        {(localStorage?.roleName === "Admin" &&
          (localStorage?.departmentId === "null" ||
            Number(localStorage?.getItem("departmentId")) === 1 ))
            //  || Number(localStorage?.departmentId) === selectedRole?.departmentID)
              &&
          featuresAccess?.addTeamMembers && (
            <Button
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              startIcon={<AddIcon />}
              onClick={() =>{ setInviteDrawer(true);
                sessionStorage.clear();
              }}
              // onClick={() => {
              //   setOpenUploadDSBatch(true);
              // }}
              className={classes.upload}
            >
              Add team member
            </Button>
          )}
        <Drawer
          anchor="right"
          open={inviteDrawer}
          onClose={() => setInviteDrawer(false)}
          classes={{ paper: classes.drawerPaper }}
        >
          {/* <CreateNewRole setOpen={setOpen} departmentAPI={departmentAPI} /> */}
          <InviteTeamMember
            setInviteDrawer={setInviteDrawer}
            departmentDetails={departmentDetails}
          // handleRefresh={handleRefresh}
          />
        </Drawer>
      </div>
      <TableContainer
        component={Paper}
        style={{
          borderLeft: "1px solid #bdbdbd",
          borderRight: "1px solid #bdbdbd",
          borderBottom: "1px solid #bdbdbd",
        }}
      >
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell>Team Member</TableCell>
              <TableCell>Phone</TableCell>
              <TableCell>Employee Number</TableCell>
              <TableCell>Department - Role</TableCell>
              <TableCell>Status</TableCell>
             <TableCell>
                {(localStorage?.roleName === "Admin" &&
                 (localStorage?.departmentId === "null" ||
                Number(localStorage?.getItem("departmentId")) === 1 )) && featuresAccess?.viewTeamMembers && (
                  <>
                  Action
                  </> 
                  )}
                </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {teamMembersListLoading === true ? (
              <TableRow style={{ height: 150 }}>
                <TableCell colSpan={12}>
                  <div style={{ textAlign: "center" }}>
                    <CircularProgress color="primary" thickness={7} />
                  </div>
                </TableCell>
              </TableRow>
            ) : teamMembersList?.data?.length > 0 ? (
              teamMembersList?.data
                ?.filter((member) => member.account_status === "Active")
                .map((member, index) => (
                  <TableRow key={index}>
                    <TableCell
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        gap: "0.3rem",
                      }}
                    >
                      <Grid>
                        <UserAvatar profileImage={member?.profile_pic} />
                      </Grid>
                      <Grid
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "flex-start",
                        }}
                      >
                        <Typography>{member?.full_name || ""}</Typography>
                        <Typography variant="body2" color="textSecondary">
                          {member?.email_address || ""}
                        </Typography>
                      </Grid>
                    </TableCell>
                    <TableCell>{member?.phone_number || ""}</TableCell>
                    <TableCell>{member?.employee_number || ""}</TableCell>
                    <TableCell>
                      {/* {member?.department_name || "NA"} */}
                      {`${member?.department_name || ""} - ${member?.roleName || ""
                        }`}
                      <br />
                      <Typography variant="body2" color="textSecondary">
                        {member?.access ? `${member.access} access` : ""}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <span
                        className={
                          member.account_status === "Active"
                            ? classes.active
                            : classes.inactive
                        }
                      >
                        {member?.account_status || ""}
                      </span>
                    </TableCell>
                    <TableCell>
                      {/* {((localStorage?.roleName === "Admin" &&
                        localStorage?.departmentId === "null") ||
                        localStorage?.departmentId == member?.department_id) &&
                        featuresAccessTeamMembers?.viewTeamMemberDetails && (  */}
                      {(localStorage?.roleName === "Admin" &&
                     (localStorage?.departmentId === "null" ||
                   Number(localStorage?.getItem("departmentId")) === 1 ))
                    // || Number(localStorage?.departmentId) ===
                    //       member?.department_id) 
                          &&
                        featuresAccess?.viewTeamMembers && (
                          <VisibilityIcon
                            fontSize="small"
                            className={classes.multipleLogo}
                            onClick={() => handleDetailView(member)}
                          />
                        )}
                      {/* {(localStorage?.roleName === "Admin" &&
                        localStorage?.departmentId === "null") ||
                        (localStorage?.departmentId ===
                          member?.department_id && (
                          <VisibilityIcon
                            fontSize="small"
                            className={classes.multipleLogo}
                            onClick={() => handleDetailView(member)}
                          />
                        ))} */}
                    </TableCell>
                  </TableRow>
                ))
            ) : teamMembersList?.status === false ? (
              <TableRow
                style={{
                  border: "2px solid rgb(255,0,0)",
                  backgroundColor: "rgb(255,240,240)",
                  Opacity: 1,
                  textAlign: "center",
                  padding: "0.8rem",
                  fontSize: "0.875rem",
                }}
              >
                <TableCell colSpan={10} align="center">
                  'Something went wrong. Please contact Schrocken support.'
                </TableCell>
              </TableRow>
            ) : (
              <TableRow>
                <TableCell colSpan={9} align="center">
                  No records found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <Drawer
        anchor="right"
        open={ViewDetailsDrawer}
        onClose={() => setViewDetailsDrawer(false)}
        classes={{ paper: classes.drawerPaper }}
      // hideBackdrop={true}
      >
        <ViewDetails
          user={user}
          departmentDetails={fetchDepartmentsList}
          setViewDetailsDrawer={setViewDetailsDrawer}
          handleRefresh={handleRefresh}
          selectedRole={selectedRole}
        />
      </Drawer>
    </>
  );

  return (
    <div>
      <BackDropLoading />
      <Dialog open={openDialog} fullScreen>
        <Grid
          style={{
            paddingLeft: "2rem",
            paddingRight: "2rem",
            paddingTop: "2rem",
            paddingBottom: "2rem",
          }}
          container
          direction="column"
        >
          {/* Header Section */}
          <Grid
            container
            // alignItems="center"
            // justifyContent="space-between"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Button
              startIcon={<ArrowBackIosIcon />}
              onClick={handleCloseColumn}
              style={{ textTransform: "none", fontWeight: "550" }}
            >
              Back
            </Button>
            {(localStorage?.roleName === "Admin" &&
             (localStorage?.departmentId === "null" ||
                Number(localStorage?.getItem("departmentId")) === 1 ))
              //    || Number(localStorage?.departmentId) ===
              // selectedRole?.departmentID)
               &&
              featuresAccess?.deleteRole && (
                <Button
                  variant="contained"
                  onClick={handleDeleteRole}
                  style={{
                    border: "1px solid red",
                    backgroundColor: "white",
                    color: "red",
                    padding: "0.2rem",
                    paddingTop: "0.5rem",
                    paddingBottom: "0.5rem",
                    fontWeight: "550",
                    marginTop: "2rem",
                    marginRight: "1rem",
                  }}
                >
                  <DeleteOutlinedIcon style={{ color: "red" }} />
                  <Typography variant="h6" style={{ fontWeight: 550, textTransform: 'none' }}>
                    Delete Role
                  </Typography>
                </Button>
              )}
          </Grid>

          {updateError === true && (
            <Grid
              ref={(el) => {
                errRef.current = el;
              }}
              style={{
                // paddingLeft: "150px",
                paddingTop: "8px",
                width: "93%",
                paddingBottom: "16px",
              }}
            >
              {/* {Object.keys(updatedData.errorDescription).map((key) => ( */}
              <Typography
                variant="h6"
                style={{
                  border: "1px solid #FF0000",
                  backgroundColor: "#FFF0F0",
                  opacity: "1",
                  textAlign: "center",
                  padding: "0.8rem",
                  marginLeft: "4rem",
                  fontSize: "0.875rem",
                }}
              >
                {updatedData?.errorDescription
                  ? updatedData.errorDescription
                  : updatedData.errorMessage}
              </Typography>
              {/* ))}  */}
            </Grid>
          )}

          <Grid container alignItems="center">
            <Typography
              variant="h5"
              style={{ fontWeight: "600" }}
              display="inline"
            >
              {selectedRole?.departmentName
                ? selectedRole?.departmentName
                : ""}{" - "}
            </Typography>

            {editingRoleName ? (
              <>
                <TextField
                  value={roleName}
                  // onChange={(e) => setRoleName(e.target.value)}
                  onChange={(e) => {
                    const regex = /^[a-zA-Z,\-\/ ]*$/; // Allows alphabets, commas, hyphens, slashes, and spaces
                    if (regex.test(e.target.value)) {
                      setRoleName(e.target.value);
                    }
                  }}
                  onBlur={(e) => {
                    const { value } = e.target;
                    // Trim leading and trailing spaces for string values
                    if (typeof value === "string" && value.trim() !== value) {
                      setRoleName(value.trim());
                    }
                  }}
                  placeholder="Enter role name"
                  variant="outlined"
                  size="small"
                  style={{ marginRight: 8 }}
                />
                {(localStorage?.roleName === "Admin" &&
                 (localStorage?.departmentId === "null" ||
                Number(localStorage?.getItem("departmentId")) === 1 )) 
                // || Number(localStorage?.departmentId) ===
                //   selectedRole?.departmentID)
                   &&
                  featuresAccess?.editRole && (
                    <Button
                      // onClick={() => setEditingRoleName(false)}
                      onClick={handleRenameChanges}
                      variant="contained"
                      color="secondary"
                      size="small"
                      style={{ textTransform: "none", marginRight: 8 }}
                      disabled={roleName === initialRoleName}
                    >
                      Rename
                    </Button>
                  )}
                <Button
                  onClick={() => {
                    setRoleName(initialRoleName); // Reset roleName to initial value
                    setEditingRoleName(false);
                  }}
                  size="small"
                  style={{
                    textTransform: "none",
                    color: "red",
                  }}
                >
                  X
                </Button>
              </>
            ) : (
              <>
                <Typography
                  variant="h5"
                  display="inline"
                  style={{
                    cursor: "pointer",
                    fontWeight: "600",
                    textDecoration:
                      roleName !== initialRoleName ? "underline" : "none", // Apply underline if roleName has changed
                  }}
                  onClick={() => setEditingRoleName(true)}
                >
                  {roleName}
                </Typography>
                {(localStorage?.roleName === "Admin" &&
                (localStorage?.departmentId === "null" ||
                  Number(localStorage?.getItem("departmentId")) === 1 )) 
                  // || Number(localStorage?.departmentId) ===
                  // selectedRole?.departmentID)
                   &&
                  featuresAccess?.editRole && (
                    <Button
                      onClick={() => setEditingRoleName(true)}
                      style={{
                        marginLeft: 8,
                        textTransform: "none",
                        textDecoration: "underline", // Apply underline if roleName has changed
                        color: "#3f51b5", // Blue color
                      }}
                      size="small"
                    >
                      Rename
                    </Button>
                  )}
              </>
            )}
          </Grid>

          <Grid
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "start",
              gap: "0.3rem",
            }}
          >
            <Typography variant="body2" color="black">
              Created by
            </Typography>
            <UserAvatar
              createdByImage={selectedRole.createdByImage}
              createdByName={selectedRole.createdByName}
            />
            <Typography style={{ fontWeight: "600" }}>
              {selectedRole?.createdByName || ""}
            </Typography>
            <Typography style={{ color: "#808080" }}>
              {calculateDaysAgo(selectedRole?.creation_date || "")}
            </Typography>

            <Grid item></Grid>
          </Grid>
        </Grid>

        <DialogContent
          style={{
            paddingLeft: "2rem",
            paddingRight: "2rem",
            paddingTop: "2rem",
            paddingBottom: "2rem",
          }}
        >
          <Tabs
            value={view}
            onChange={handleTabChange}
            indicatorColor="secondary"
            textColor="secondary"
            style={{ color: "black" }}
          >
            <Tab
              style={{ color: view === "TeamMembers" ? "#1890ff" : "black" }}
              // label="Team Members"
              label={`Team Members (${selectedRole?.userCount || 0})`}
              value="TeamMembers"
            />
          </Tabs>
          <Grid item xs={12}>
            {view === "TeamMembers" && renderTeamMembers()}
          </Grid>
        </DialogContent>

        {DeleteCollaboratorRoleData.status === true && (
          <Dialog open={deleteRole} maxWidth="sm" fullWidth>
            <DialogContent className={classes.dialogContent}>
              <CheckCircleIcon className={classes.avatar} />

              <Typography variant="h6" style={{ marginTop: "10px" }}>
                Deleted role successfully
              </Typography>
              <Typography variant="body1" style={{ marginTop: "10px" }}>
                The role has been deleted successfully.
              </Typography>

              <DialogActions className={classes.dialogActions}>
                <Button
                  variant="contained"
                  color="primary"
                  endIcon={<ChevronRight />}
                  style={{
                    borderRadius: "20px",
                    textTransform: "none",
                  }}
                  onClick={handleConfirmDelete}
                >
                  Ok
                </Button>
              </DialogActions>
            </DialogContent>
          </Dialog>
        )}
      </Dialog>

      {/* <Dialog open={openSuccessDialog} maxWidth="sm" fullWidth>
        <DialogContent className={classes.dialogContent}>
          <CheckCircleIcon className={classes.avatar} />

          <Typography variant="h6" style={{ marginTop: "10px" }}>
            Role details updated successfully
          </Typography>
          <Typography variant="body1" style={{ marginTop: "10px" }}>
            The role details have been updated successfully.
          </Typography>

          <DialogActions className={classes.dialogActions}>
            <Button
              variant="contained"
              color="primary"
              endIcon={<ChevronRight />}
              style={{
                borderRadius: "20px",
                textTransform: "none",
              }}
              onClick={handleClose}
            >
              Ok
            </Button>
          </DialogActions>
        </DialogContent>
      </Dialog> */}

      <Drawer
        anchor="right"
        open={openDrawer}
        onClose={() => setOpenDrawer(false)}
      >
        <Box
          width={410}
          p={3}
          display="flex"
          flexDirection="column"
          height="100%"
        >
          <Typography variant="h6" style={{ fontWeight: 550 }}>
            Delete role
          </Typography>
          <hr
            width={410}
            style={{
              backgroundColor: "grey",
              height: "1px",
              margin: "inherit",
              marginBottom: "1rem",
              marginTop: "1rem",
            }}
          />

          <Typography
            variant="h6"
            style={{ fontWeight: 600, marginBottom: "0.5rem" }}
          >
            Assign Alternate department-role(s)
          </Typography>

          {teamMembersList?.data
            ?.filter((member) => member.account_status === "Active")
            ?.map((user, index) => {
              const isDepartmentSelected =
                !!userDepartmentRole[user.saas_user_id]?.selectedDepartmentID;
              const isRoleSelected =
                !!userDepartmentRole[user.saas_user_id]?.selectedRole;

              return (
                <Box
                  key={user.saas_user_id}
                  style={{
                    backgroundColor:
                      (isDepartmentSelected && isRoleSelected) ||
                        autofillChecked
                        ? "#f3faee"
                        : "#ffe6e6",
                    marginBottom: "0.5rem",
                    marginRight: "1rem",
                    paddingLeft: "1rem",
                    paddingTop: "1rem",
                    paddingBottom: "1rem",
                    paddingRight: "1rem",
                    borderRadius: "0.2rem",
                  }}
                  width="90%"
                >
                  <Grid
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "flex-start",
                    }}
                  >
                    <Grid>
                      <UserAvatar profileImage={user?.profile_pic} />
                    </Grid>
                    <Grid
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                      }}
                    >
                      <Typography
                        style={{ fontWeight: "bold", fontSize: "0.8rem" }}
                      >
                        {user.full_name}
                      </Typography>
                      <Typography
                        style={{ fontSize: "0.8rem" }}
                        variant="body2"
                        color="textSecondary"
                      >
                        {user.email_address}
                      </Typography>
                    </Grid>
                  </Grid>

                  {/* <FormControl fullWidth style={{ marginTop: 10 }}>
                    <Typography
                      variant="body1"
                      style={{ marginBottom: 5, fontWeight: 550 }}
                    >
                      Select Department{" "}
                      <span style={{ color: "red", fontWeight: "bold" }}>
                        {" "}
                        *
                      </span>
                    </Typography>

                    <TextField
                      size="small"
                      select
                      variant="outlined"
                      fullWidth
                      value={
                        autofillChecked &&
                        user.saas_user_id !== getFirstUserId()
                          ? userDepartmentRole[getFirstUserId()]
                              ?.selectedDepartmentID
                          : userDepartmentRole[user.saas_user_id]
                              ?.selectedDepartmentID || ""
                      }
                      onChange={(e) =>
                        handleDepartmentChange(
                          user.saas_user_id,
                          e.target.value
                        )
                      }
                      disabled={
                        autofillChecked &&
                        user.saas_user_id !== getFirstUserId()
                      }
                    >
                      {fetchDepartmentsList?.map((department) => (
                        <MenuItem
                          key={department.departmentID}
                          value={department.departmentID}
                        >
                          {department.departmentName}
                        </MenuItem>
                      ))}
                    </TextField>
                  </FormControl>

                  <FormControl fullWidth style={{ marginTop: 10 }}>
                    <Typography variant="body1" style={{ marginBottom: 5 }}>
                      Select Role{" "}
                      <span style={{ color: "red", fontWeight: "bold" }}>
                        {" "}
                        *
                      </span>
                    </Typography>
                    <TextField
                      select
                      variant="outlined"
                      size="small"
                      fullWidth
                      value={
                        autofillChecked &&
                        user.saas_user_id !== getFirstUserId()
                          ? userDepartmentRole[getFirstUserId()]?.selectedRole
                          : userDepartmentRole[user.saas_user_id]
                              ?.selectedRole || ""
                      }
                      onChange={(e) =>
                        handleRoleChange(user.saas_user_id, e.target.value)
                      }
                      disabled={
                        autofillChecked &&
                        user.saas_user_id !== getFirstUserId()
                      }
                    >
                      {(autofillChecked
                        ? userDepartmentRole[getFirstUserId()]?.markedDepartment
                            ?.rolesList
                        : userDepartmentRole[user.saas_user_id]
                            ?.markedDepartment?.rolesList
                      )
                        ?.filter(
                          (role) => role.role_name !== initialRoleName
                          // role.collaborator_role_id !== selectedRole.collaborator_role_id
                        )
                        ?.map((role) => (
                          <MenuItem key={role.role_name} value={role.role_name}>
                            {role.role_name}
                          </MenuItem>
                        ))}
                    </TextField>
                  </FormControl> */}

                  <FormControl fullWidth style={{ marginTop: 10 }}>
                    <Typography
                      variant="body1"
                      style={{ marginBottom: 5, fontWeight: 550 }}
                    >
                      Select Department{" "}
                      <span style={{ color: "red", fontWeight: "bold" }}>
                        *
                      </span>
                    </Typography>
                    <TextField
                      size="small"
                      select
                      variant="outlined"
                      fullWidth
                      value={
                        autofillChecked &&
                          user.saas_user_id !== getFirstUserId()
                          ? userDepartmentRole[getFirstUserId()]
                            ?.selectedDepartmentID
                          : userDepartmentRole[user.saas_user_id]
                            ?.selectedDepartmentID || ""
                      }
                      onChange={(e) =>
                        handleDepartmentChange(
                          user.saas_user_id,
                          e.target.value
                        )
                      }
                      // disabled={
                      //   autofillChecked &&
                      //   user.saas_user_id !== getFirstUserId()
                      // }
                      disabled={autofillChecked}
                    >
                      {fetchDepartmentsList
                        ?.filter((department) =>
                          Number(localStorage?.departmentId) ===
                            selectedRole?.departmentID
                            ? department.departmentID ===
                            selectedRole?.departmentID
                            : true
                        )
                        .map((department) => (
                          <MenuItem
                            key={department.departmentID}
                            value={department.departmentID}
                          >
                            {department.departmentName}
                          </MenuItem>
                        ))}
                    </TextField>
                  </FormControl>

                  <FormControl fullWidth style={{ marginTop: 10 }}>
                    <Typography variant="body1" style={{ marginBottom: 5 }}>
                      Select Role{" "}
                      <span style={{ color: "red", fontWeight: "bold" }}>
                        *
                      </span>
                    </Typography>
                    <TextField
                      select
                      variant="outlined"
                      size="small"
                      fullWidth
                      value={
                        autofillChecked &&
                          user.saas_user_id !== getFirstUserId()
                          ? userDepartmentRole[getFirstUserId()]?.selectedRole
                          : userDepartmentRole[user.saas_user_id]
                            ?.selectedRole || ""
                      }
                      onChange={(e) =>
                        handleRoleChange(user.saas_user_id, e.target.value)
                      }
                      // disabled={
                      //   autofillChecked &&
                      //   user.saas_user_id !== getFirstUserId()
                      // }
                      disabled={autofillChecked}
                    >
                      {fetchDepartmentsList
                        ?.find(
                          (dept) =>
                            dept.departmentID ===
                            (autofillChecked
                              ? userDepartmentRole[getFirstUserId()]
                                ?.selectedDepartmentID
                              : userDepartmentRole[user.saas_user_id]
                                ?.selectedDepartmentID)
                        )
                        ?.rolesList?.filter(
                          (role) => role.role_name !== selectedRole?.role_name
                        )
                        ?.map((role) => (
                          <MenuItem key={role.role_name} value={role.role_name}>
                            {role.role_name}
                          </MenuItem>
                        ))}
                    </TextField>
                  </FormControl>

                  {index === 0 && (
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={autofillChecked}
                          disabled={!isDepartmentSelected || !isRoleSelected}
                          onChange={handleAutofillChange}
                        />
                      }
                      label="Assign same alternate department-role to remaining team members"
                    />
                  )}
                </Box>
              );
            })}

          <Box
            display="flex"
            justifyContent="space-between"
            mt="auto"
            style={{ marginBottom: "1rem" }}
          >
            <Button
              variant="contained"
              color="secondary"
              onClick={() => setOpenDrawer(false)}
              style={{
                backgroundColor: "rgba(209, 210, 214, 0.94)",
                color: "black",
              }}
            >
              Back
            </Button>
            <Button
              variant="contained"
              color="secondary"
              onClick={handleConfirmChanges}
              style={{
                backgroundColor: "#286acf",
                color: "#fff",
              }}
              disabled={
                !teamMembersList?.data?.every(
                  (user) =>
                    !!userDepartmentRole[user.saas_user_id]
                      ?.selectedDepartmentID &&
                    !!userDepartmentRole[user.saas_user_id]?.selectedRole
                )
              }
            >
              confirm Changes
            </Button>
          </Box>
        </Box>
      </Drawer>

      <Backdrop className={classes.backdrop}>
        <Drawer
          anchor="right"
          open={showDrawer}
          onClose={() => setShowDrawer(false)}
        >
          <Box
            width={410}
            p={3}
            height="100%"
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            <Box>
              <Typography variant="h6" fontWeight="bold" mb={2}>
                Delete department
              </Typography>
              <hr className={classes.hr} />
              <Typography variant="body1" gutterBottom>
                <b>Warning:</b>
              </Typography>
              <Typography
                variant="body2"
                style={{
                  border: "2px solid red", // Red border
                  borderRadius: "4px",
                  padding: "8px",
                  fontWeight: "bold",
                  color: "red", // Red text
                  lineHeight: 1.5,
                }}
              >
                Role deletion: You are deleting the role. Team members may lose
                access to certain areas of the application. You can't reverse
                this process. To proceed, please assign alternate
                department-role(s) for all the affected team members.
              </Typography>
            </Box>

            <Box
              display="flex"
              justifyContent="space-between"
              style={{ paddingBottom: "1rem" }}
              mt={4}
            >
              <Button
                variant="outlined"
                onClick={() => setShowDrawer(false)}
                style={{
                  textTransform: "none",
                  borderRadius: "8px",
                }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                color="primary"
                //onClick={() => handleProceedDelete(department.departmentID,department.tempID)}
                // onClick={() => handleProceedDelete(selectedDepartment.departmentID,selectedDepartment.tempID)}
                onClick={handleProceedDelete}
                style={{
                  textTransform: "none",
                  borderRadius: "8px",
                  backgroundColor: "#1976D2",
                }}
              >
                Proceed
              </Button>
            </Box>
          </Box>
        </Drawer>
      </Backdrop>
    </div>
  );
};

export default EditTeamMembersColumn;
